// removed by extract-text-webpack-plugin
module.exports = {"modal":"src-components-Messages-Blasts-__PreviewDestination__modal--1GZia","close":"src-components-Messages-Blasts-__PreviewDestination__close--3SEI9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Blasts/PreviewDestination.css
// module id = 1967
// module chunks = 0